import React from "react";
import { FiCreditCard } from "react-icons/fi";
import { PiIdentificationCard } from "react-icons/pi";
import inputImage from "../../../../assets/images/Calque_2.png";
import defaultImage from "../../../../assets/images/bg-image-removebg-preview.png";
import { CiImageOn } from "react-icons/ci";
import ImageUpload from "./IDCapture";

export default function UploadDocument({ handleNext, handleFileUpload, handleDrop, formData, setFormData, frontInputRef, backInputRef }) {
    return (
        <div className="tw-w-[80%] max-sm:tw-w-[95%] tw-mx-auto tw-p-6 max-sm:tw-p-4">
            <div className="tw-mb-6 max-sm:tw-mb-4">
                <h1 className="tw-text-[20px] max-sm:tw-text-[18px] tw-font-semibold tw-text-black tw-mb-2 tw-border-dashed tw-text-center">
                    Upload Your Document
                </h1>

                <div className="tw-text-black tw-text-sm max-sm:tw-text-xs tw-mb-4 tw-leading-tight">
                    <p className="tw-mb-2">Instructions:</p>
                    <p className="tw-mb-1">• Please upload a clear image or scan of your selected document.</p>
                </div>
            </div>

            <div className="tw-flex tw-flex-col lg:tw-flex-row tw-gap-4 max-sm:tw-gap-3">
                <ImageUpload formData={formData} setFormData={setFormData} label={"Front Side"} name={"frontSide"} />
                <ImageUpload formData={formData} setFormData={setFormData} label={"Back Side"} name={"backSide"} />
            </div>

            <p className="tw-text-red-500 tw-text-sm max-sm:tw-text-xs tw-mb-4 tw-w-full tw-text-end max-sm:tw-text-center">
                *Ensure your ID is current and not expired
            </p>

            <button
                onClick={handleNext}
                className="tw-mx-auto tw-flex tw-justify-center tw-items-center tw-px-20 max-sm:tw-px-8 tw-bg-primary tw-text-white tw-py-2 max-sm:tw-py-3 tw-rounded-md hover:tw-bg-primary-hover tw-transition-colors tw-w-full tw-font-semibold"
            >
                Next
            </button>
        </div>
    );
}
